import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Field } from 'redux-form';
import { FormattedMessage } from 'translations';
import { Layout } from 'app/components/base/Layout';
import Icon from 'app/components/base/Icon';
import TransitionInput from 'app/components/base/TransitionInput';
import Button from 'app/components/base/Button';
import { getCustomerProfileList } from 'app/actions/travel-agent';
import { deselectProfile } from 'app/actions/book-trip';
import { SELECTED_CUSTOMER_PROFILE } from 'app/constants';
import { behavesAsTravelAgent, getSelectedCustomerProfile } from 'app/sagas/selectors';

import style from './style.css';


export const messages = {
  selectedProfile: { id: 'BOOK_TRIP.CONTACT_INFO.SELECTED_PROFILE' },
  selectedProfilePlaceholder: { id: 'BOOK_TRIP.CONTACT_INFO.SELECTED_PROFILE_PLACEHOLDER' },
  deselectProfile: { id: 'BOOK_TRIP.CONTACT_INFO.DESELECT_PROFILE' }
};

const getProfileName = (profile = { profile_name: '' }) =>
  profile.profile_name

export default function ProfileSelector() {
  const dispatch = useDispatch()
  const behavesAsTA = useSelector(behavesAsTravelAgent)
  const profileList = useSelector((state) => state.travelAgent.profileList)
  const selectedProfile = useSelector(getSelectedCustomerProfile)

  React.useEffect(() => {
    if (behavesAsTA) {
      dispatch(getCustomerProfileList())
    }
  }, [behavesAsTA])

  return (profileList && !!profileList.length &&
    <Layout
      className={style.container}
      direction="row"
      size="noshrink"
      align="space-between end"
    >
      <Field
        compact
        component={TransitionInput}
        errorClassName={style.field}
        labelClassName={style.label}
        label={<FormattedMessage {...messages.selectedProfile} />}
        placeholder={<FormattedMessage {...messages.selectedProfilePlaceholder} />}
        options={profileList}
        template={getProfileName}
        name={SELECTED_CUSTOMER_PROFILE}
        type="options"
        size="noshrink"
        upwards
        deanimate
      />
      {!!selectedProfile && (
        <Button
          onClick={() => dispatch(deselectProfile())}
          className={style.deselectButton}
          outlined
          rounded
          nocaps
        >
          <FormattedMessage {...messages.deselectProfile} />
          <Icon family="mozio" className={style.deselectIcon}>close-circle-outline</Icon>
        </Button>
      )}
    </Layout>
  );
}
